<template>

    <calendar
        ref="calendar"
        :events="calendar.events" 
        :lunar="calendar.lunar" 
        :value="calendar.value" 
        :begin="calendar.begin" 
        :end="calendar.end" 
        :weeks="calendar.weeks" 
        :months="calendar.months" 
        @select="calendar.select"></calendar>
</template>

<script>
 
import calendar from './calendar.vue'

export default {
    components: {
        calendar
    },
    data(){
        return {
            calendar:{
                value:[], //默认日期（为空时默认选中今天）
                begin:[], //开始选择日期
                lunar:true, //显示农历
                weeks:['日', '一', '二', '三', '四', '五', '六'],
                months:['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                events:{
                    /*'2019-9-7':'$408',
                    '2019-9-20':'$408',
                    '2019-9-21':'$460',
                    '2019-9-22':'$500',
                    '2019-10-1':'$500',
                    '2019-10-7':'$500',
                    '2019-10-13':'$500',
                    '2019-11-30':'$500',*/
                },
//              select(value){
	// value.toString()
//              },
                // timestamp:Date.now()
            }
        }
    },
    created(){
		this.dataPrice(this.$route.query);
　　	 	this.setToday();
    },
    mounted() {
    	
	},
    methods:{
        setToday(){
            let now = new Date();
            this.year = now.getFullYear()
            this.month = now.getMonth()+1
            this.day = now.getDate()
            // this.calendar.value.push(this.year)
            // this.calendar.value.push(this.month)
            // this.calendar.value.push(this.day)
            this.calendar.begin = this.calendar.value
            
        },
        //获取日历价格
	    dataPrice({ departure, destination, departure_date }) {
            let that = this;
           /* setTimeout(function (){
	        		that.calendar.events={
                    '2019-9-7':'$408',
                    '2019-9-20':'$408',
                    '2019-9-21':'$460',
                    '2019-9-22':'$500',
                    '2019-10-1':'$500',
                    '2019-10-7':'$500',
                    '2019-10-13':'$500',
                    '2019-11-30':'$500',
                }
	        	},1000);*/
		    this.$api
		        .post("/air/member/booking/calendar", {
		          arrive_city_code: destination,
		          depart_city_code: departure,
		          departure_date: departure_date
	        })
	        .then(res => {
	        	var jsons = {};
	        	for(let i in res.list) {
	        		let str = "'"+res.list[i].date+"'";//'2019-09-09'
	        		let year = str.substr(1,4);
		    		let month = str.substr(6,2);
		    		let day = str.substr(9,2);
		    		if(month < 10) {
		    			month = month.substr(1,1);
		    		}
		    		if(day < 10) {
		    			day = day.substr(1,1);
		    		}
		    		let name = year+"-"+month+"-"+day;
	        		
	        		jsons[name] = '￥'+res.list[i].price;
	        	}
	        	
	        	that.calendar.events = jsons;

	        })
	        .catch(err => {
		        let keys = Object.keys(err);
		     	let key = keys[0];
		  		let message = err.message || err[key][0]
//			    this.$toast(message);
			    if(message.slice(0, 10) == 'timeout of') {
		  			this.$toast('网络不给力，请稍候重试');
		  		}else {
		  			this.$toast(message);
		  		}
	        });
	    }
    }
}
</script>


